import isObject from './isObject.js';

const mergeObjects = (master, slave) => {
  const duplicatedMaster = JSON.parse(JSON.stringify(master));
  Object.keys(slave).forEach((prop) => {
    const key = prop;
    if (key in slave && isObject(slave[key])) {
      duplicatedMaster[key] = mergeObjects(duplicatedMaster[key], slave[key]);
    } else {
      duplicatedMaster[key] = slave[key];
    }
  });
  return duplicatedMaster;
};
var mergeObjects$1 = mergeObjects;

export { mergeObjects$1 as default };
